import React, { useContext } from 'react';
import { PayPalButton } from 'react-paypal-button-v2';
import { createOrder, captureOrder } from 'services/home';
import { AppContext } from 'context/AppContext';
import moment from 'moment';

const InfoAboutFullFunctionalityPro = (props) => {
    let appContext = useContext(AppContext);

    let currentDate = moment();
    let endSubscription = moment(appContext.defaults.sub_end_date);
    if (currentDate > endSubscription) {
        endSubscription = currentDate.add(1, 'Y');
    } else {
        endSubscription = endSubscription.add(1, 'Y');
    }
    endSubscription = endSubscription.format('YYYY/MM/DD');

    return (
        <div className="finalise-purches">
            <div className="header-box-left">
                <div className="header-left">
                    {props.isRenewing
                        ? 'Renew to keep full functionality'
                        : 'Go Pro to access full functionality'}
                </div>
            </div>

            <div className="checked-list">
                <div className="checked-list-li">
                    <div className="checked-mark"></div>
                    <div className="description">Up to 60 projects</div>
                </div>
                <div className="checked-list-li">
                    <div className="checked-mark"></div>
                    <div className="description">Sampling</div>
                </div>
                <div className="checked-list-li">
                    <div className="checked-mark"></div>
                    <div className="description">
                        A Variety of Univariate Analyses
                    </div>
                </div>
                <div className="checked-list-li">
                    <div className="checked-mark"></div>
                    <div className="description">
                        A Variety of Multivariate Analyses
                    </div>
                </div>
                <div className="checked-list-li">
                    <div className="checked-mark"></div>
                    <div className="description">
                        Conditional Transformations
                    </div>
                </div>
            </div>

            {props.isRenewing ? (
                <div
                    style={{
                        fontFamily: 'Roboto Bold',
                        fontSize: '14px',
                        lineHeight: '24px',
                        color: '#3D3F4D',
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: 6,
                        marginBottom: 5
                    }}
                >
                    <div>
                        After renewal, your subscription will be valid <br />
                        until: {endSubscription}
                    </div>
                    {/* <div style={{ margin: '10px auto', fontSize: '16px' }}>
                        {endSubscription}
                    </div> */}
                </div>
            ) : null}

            <div className="price-box-left">
                <div className="mark-dolar">$</div>
                <div className="price">85</div>
                <div className="per-year">/ year</div>
            </div>

            {/* <div className="buttons-box">
                <div
                    className="btn-renew-now"
                    onClick={() => {
                        props.setIsSubscribe(true);
                    }}
                >
                    go pro now
                </div>
            </div> */}
            <div style={{ marginTop: '25px' }}>
                <PayPalButton
                    // amount="0.01"
                    // shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
                    createOrder={(data, action) => {
                        let request_body = {
                            sub_type: 1
                        };

                        return createOrder(request_body).then((res) => {
                            return res.data.paypal_order_id;
                        });
                    }}
                    onApprove={(data, action) => {
                        captureOrder(data.orderID).then((res) => {
                            // console.log(res.data);
                            appContext.syncTokenFromSessionStore();
                        });
                        appContext.setDefault('sub_is_active', true);
                    }}
                    options={{
                        clientId: appContext.defaults.paypal_client_id
                    }}
                />
            </div>
        </div>
    );
};

export default InfoAboutFullFunctionalityPro;
